import React from "react";
import { Modal, message } from "antd";
import { StopOutlined } from "@ant-design/icons";
import "../workingmonth.css";
import axios from "axios";
import { API_URL } from "../../../constants";
import { useSelector } from "react-redux";

export default function DeleteModal({ setIsModalVisible, isModalVisible }) {
  const accessToken = useSelector(
    (state) => state.user.currentUser?.accessToken
  );

  const handleCloseModal = () => {
    if (typeof isModalVisible === "object") {
      setIsModalVisible(null);
    } else setIsModalVisible(false);
  };

  const [loading, setLoading] = React.useState(false);
  const fullName =
    [isModalVisible.nume, isModalVisible.prenume].filter(Boolean).join(" ") ||
    "utilizatorul";

  // soft delete: contul devine inactiv, datele si istoricul raman
  const deleteUser = async () => {
    setLoading(true);
    try {
      await axios.post(
        API_URL + "user/us/delete",
        { id: isModalVisible.id },
        { headers: { Authorization: "Bearer " + accessToken } }
      );
      message.success(`${fullName} a fost dezactivat.`);
      setIsModalVisible(false);
    } catch (error) {
      console.log(error);
      message.error(error.response?.data?.message || "Dezactivarea a eșuat.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      title={`Dezactivează utilizatorul ${fullName}`}
      open={isModalVisible}
      onCancel={handleCloseModal}
      footer={null}
      destroyOnClose
    >
      {/* modalul antd se randeaza in afara .wm-page: reaplicam stilul wm */}
      <div className="wm-page" style={{ maxWidth: "none" }}>
        <p style={{ margin: "4px 0 18px", color: "var(--wm-ink-2)" }}>
          Contul nu va mai putea intra în aplicație, iar sesiunile lui active se
          închid. Datele și istoricul (indici, recalcule, importuri) rămân
          legate de utilizator. Îl puteți reactiva oricând din filtrul
          „Inactivi”.
        </p>
        <div style={{ display: "flex", gap: 8, justifyContent: "flex-end" }}>
          <button
            type="button"
            className="wm-btn wm-btn-secondary"
            onClick={handleCloseModal}
          >
            Anulează
          </button>
          <button
            type="button"
            className={`wm-btn wm-btn-danger${loading ? " wm-btn-loading" : ""}`}
            disabled={loading}
            onClick={deleteUser}
          >
            {loading ? <span className="wm-spin" /> : <StopOutlined />}
            Da, dezactivează
          </button>
        </div>
      </div>
    </Modal>
  );
}
